import React from "react";
import { Box, Typography } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";

const FeatureUnavailablePage: React.FC = () => {
  const { t } = useKivunovaTranslation();

  return (
    <Box
      data-testid="feature-unavailable-page"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "40vh",
        px: 2,
        textAlign: "center"
      }}
    >
      <Typography variant="h5" component="h1" gutterBottom>
        {t("feature-unavailable-title", "Feature not available")}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {t(
          "feature-unavailable-body",
          "This area is not available for your organization or subscription."
        )}
      </Typography>
    </Box>
  );
};

export default FeatureUnavailablePage;
